(function () {
  const selector = ".index_prod_videos_sec_NEW";
  let scrollTop = 0;

  function closePopup(popup) {
    if (!popup?.classList.contains("active")) return;
    popup.classList.remove("active");
    popup.setAttribute("aria-hidden", "true");
    const video = popup.querySelector(".prodVideo_ContentMain video");
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    document.body.classList.remove("video-product-modal-open");
    document.body.style.top = "";
    window.scrollTo(0, scrollTop);
  }

  function setupPreview(video, requestedStart) {
    if (!video || video.dataset.previewReady) return;
    video.dataset.previewReady = "true";
    video.muted = true;
    const begin = () => {
      const duration = Number.isFinite(video.duration) ? video.duration : 0;
      const start = Math.min(
        Math.max(requestedStart, 0),
        Math.max(duration - 0.1, 0),
      );
      const end = Math.min(start + 5, duration);
      if (!duration || end <= start) return;
      video.currentTime = start;
      video.play().catch(() => {});
      video.addEventListener("timeupdate", () => {
        if (video.currentTime >= end) {
          video.currentTime = start;
          video.play().catch(() => {});
        }
      });
    };
    if (video.readyState >= 1) begin();
    else video.addEventListener("loadedmetadata", begin, { once: true });
  }

  function initSection(section) {
    if (!section || section.dataset.videoProductReady) return;
    section.dataset.videoProductReady = "true";
    section.querySelectorAll(".index_video_product_card").forEach((card) => {
      const trigger = card.querySelector(".initialBox");
      const popup = card.querySelector(".prodVideo_ContentWrap");
      const popupVideo = popup?.querySelector(".prodVideo_ContentMain video");
      const soundButton = popup?.querySelector(".soundControl");
      setupPreview(
        card.querySelector(".mediaWrap video"),
        Number.parseFloat(trigger?.dataset.videostart) || 0,
      );
      if (!trigger || !popup) return;

      const openPopup = () => {
        scrollTop = window.scrollY;
        popup.classList.add("active");
        popup.setAttribute("aria-hidden", "false");
        document.body.classList.add("video-product-modal-open");
        document.body.style.top = `-${scrollTop}px`;
        popupVideo?.play().catch(() => {});
        popup.querySelector(".closeBtn")?.focus();
      };
      trigger.addEventListener("click", openPopup);
      trigger.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          openPopup();
        }
      });
      popup
        .querySelector(".closeBtn")
        ?.addEventListener("click", () => closePopup(popup));
      popup
        .querySelector(".popOverlay")
        ?.addEventListener("click", () => closePopup(popup));
      soundButton?.addEventListener("click", () => {
        if (!popupVideo) return;
        popupVideo.muted = !popupVideo.muted;
        soundButton.classList.toggle("unmute", !popupVideo.muted);
        soundButton.setAttribute(
          "aria-label",
          popupVideo.muted ? "Unmute video" : "Mute video",
        );
      });
    });
  }

  function init(root) {
    if (root.matches?.(selector)) initSection(root);
    root.querySelectorAll?.(selector).forEach(initSection);
  }
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape")
      closePopup(
        document.querySelector(`${selector} .prodVideo_ContentWrap.active`),
      );
  });
  document.addEventListener("DOMContentLoaded", () => init(document));
  document.addEventListener("shopify:section:load", (event) =>
    init(event.target),
  );
})();
